const IconCard = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4451 15.5412H18.1115V13.3387H14.4451V15.5412Z"
      fill="#333030"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.12091 4.66124L2.22215 3.56H21.7779L22.8791 4.66124V19.3285L21.7779 20.4297H2.22215L1.12091 19.3285V4.66124ZM3.32339 5.76248V8.45018H20.6766V5.76248H3.32339ZM3.32339 18.2272V10.6527H20.6766V18.2272H3.32339Z"
      fill="#333030"
    />
  </svg>
);

export default IconCard;
